
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class MarkUpPolicyGrid extends Serenity.EntityGrid<MarkUpPolicyRow, any> {
        protected getColumnsKey() { return 'OMS.MarkUpPolicy'; }
        protected getDialogType() { return MarkUpPolicyDialog; }
        protected getIdProperty() { return MarkUpPolicyRow.idProperty; }
        protected getInsertPermission() { return MarkUpPolicyRow.insertPermission; }
        protected getLocalTextPrefix() { return MarkUpPolicyRow.localTextPrefix; }
        protected getService() { return MarkUpPolicyService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}